import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useDestroyOne } from '../../../hooks';
import { deleteAdminLeadProposalRequest } from '../../../requests/admin/leadProposals';
import { deleteProposalAdminInsurancePolicyRequest } from '../../../requests/admin/adminInsurancePolicies';
import LeadEdit from '../../../screens/Lead/LeadEdit';
import { camelCase } from '../../../services/utils';
import sendDocumentEmail from '../../Shared/SendDocumentEmail';
import { leadProps } from '../../Shared/SendEmailModalProps';
import { IconBtn } from '../../Utils/Button';
import { InfoCard } from '../../Utils/Cards';
import leadObject from './leadObject';

const InfoCardLead = ({ fromAdmin, lead, modelUrl, setMoreData }) => {
  const history = useHistory();

  const [modalShow, setModalShow] = useState(false);

  const { SendEmailModal, openEmailModal } = sendDocumentEmail({
    fromAdmin,
    executiveModel: { id: lead.id, name: 'Lead' }
  });

  const { closeStatus } = lead;

  const translatedStatuses = {
    contractIssued: { title: 'Póliza emitida', variant: 'success' },
    failure: { title: 'Cierre sin éxito', variant: 'danger' },
    proposalGenerated: { title: 'Propuesta generada', variant: 'warning' },
    success: { title: 'Cierre con éxito', variant: 'secondary-light' }
  };

  const currentCloseStatus = translatedStatuses[camelCase(closeStatus)];

  const { handleShowModal, OnDestroyModalComponent } = useDestroyOne({
    deleteRequest: deleteAdminLeadProposalRequest,
    parentId: lead.id,
    modelName: 'Propuesta',
    nameEndsInA: true,
    setMoreData
  });

  const { handleShowModal: deleteProposal, OnDestroyModalComponent: DeleteProposalModalComponent } = useDestroyOne({
    deleteRequest: deleteProposalAdminInsurancePolicyRequest,
    modelName: 'Propuesta',
    nameEndsInA: true,
    setMoreData
  });

  const leadInfo = leadObject({ history, modelUrl, deleteProposal, fromAdmin, handleShowModal, lead, openEmailModal });

  const handleModalClose = () => setModalShow(false);

  const onStep = value => lead.step === value;

  return (
    <InfoCard
      title="Información cobertura"
      object={leadInfo}
      className="h-100"
      iconBtnComponent={
        <>
          {onStep('closed') && (
            <IconBtn noBtn variant={currentCloseStatus.variant} className="no-shadow non-clickable btn-sm">
              {currentCloseStatus.title}
            </IconBtn>
          )}
          {(onStep('oportunity') || onStep('renewal') || fromAdmin) && (
            <IconBtn
              onClick={() => setModalShow(true)}
              icon="pen"
              className="btn edit-btn no-shadow"
              variant="primary-dark"
              size="xs"
            />
          )}
        </>
      }
    >
      <LeadEdit
        onStep={onStep}
        lead={lead}
        fromAdmin={fromAdmin}
        modalShow={modalShow}
        handleModalClose={handleModalClose}
        setMoreData={setMoreData}
      />
      <OnDestroyModalComponent />
      <DeleteProposalModalComponent />
      <SendEmailModal {...leadProps({ lead })} />
    </InfoCard>
  );
};

export default InfoCardLead;
